
import ReusableLink from '../common/ReusableLink.vue';
export default {
    name: "BlogSideWidget",
    props: {
        data: {
            type: Object,
            default: () => ({
                ButtonText: "查看更多",
                ButtonLink: "https://google.com",
                mode: "1"
            }),
        },
        contentAnchorData: {}
    },
    data() {
        return {
            activeItemId: 0,
            backgroundImg: "cross-selling-banner-tutorial.png",
            isHandlerActive: false,
        };
    },
    computed: {
        backgroundImageInlineStyle() {
            // return `background-image: url("./assets/images/${this.backgroundImg}");`;
            const bgImage = require(`@/assets/images/${this.backgroundImg}`);
            return `background-image: url( ${bgImage} ); `;
        },
        backgroundImageInlineStyle2() {
            // return `background-image: url("./assets/images/${this.backgroundImg}");`;
            const bgImage = require(`@/assets/images/${this.backgroundImg}`);
            return `background-image: url( ${bgImage} ); `;
        }
    },
    methods: {
        openAnchorWidget() {
            this.isHandlerActive = !this.isHandlerActive
            this.$emit("showBlogSideWidget", true)
        },
        closeAnchorWidget() {
            this.$emit("showBlogSideWidget", false)
        },
    },
    components: {  }
}
